/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";

class CloseButtonWithoutRouter extends React.PureComponent<RouteComponentProps<any>, {}> {
    public render() {
        return (
            <button className="btn-flat right btn-large" onClick={this.cancel}>
                <i className="material-icons">close</i>
            </button>
        );
    }

    private cancel = () => {
        const { history } = this.props;
        history.goBack();
    };
}

export const CloseButton = withRouter(CloseButtonWithoutRouter);
